<template id="view-security-params">
  <div class="container-fluid">
    <div class="row top-row">
      <div class="col-12">
        <h3>Auditoria</h3>
      </div>
    </div>
    <div class="row"><br /></div>
    <div class="row">
      <div
        class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 e-control e-lib"
      >
        <div class="card">
          <div class="card-body">
            <div class="form-group">
              <div class="row"><br /></div>
              <div class="row" style="text-align: left">
                <div class="col-xs-12 col-sm-6 col-lg-6 col-md-6">
                  <label class="e-text">Componente</label>
                  <ejs-dropdownlist
                    ref="componentDropDown"
                    id="componentId"
                    :dataSource="componentsList"
                    :fields="fields"
                    v-model="m_data.id"
                    :value="m_data.id"
                    placeholder="Componente"
                    :cssClass="hasError('id') ? 'e-warning' : ''"
                    @change="validateField('id', true)"
                    @blur="validateField('id')"
                  ></ejs-dropdownlist>
                  <span
                    class="help e-text small"
                    :class="{ 'e-warning': hasError('id') }"
                    v-text="m_errors.id"
                  >
                  </span>
                </div>
                <div class="col-xs-12 col-sm-6 col-lg-4 col-md-4 classEspecial">
                  <div>
                    <div class="e-btn-group">
                      <ejs-button
                        @click.native="searchData"
                        :isPrimary="true"
                        iconCss="e-icons e-search inline-command"
                        cssClass="e-flat e-noback"
                        >Consultar</ejs-button
                      >
                    </div>
                  </div>
                </div>
              </div>
              <div class="row"><br /></div>
              <div class="row">
                <ejs-tab id="element" ref="tabGrid">
                  <div class="e-tab-header">
                    <div>Datos Actuales</div>
                    <div>Historial Auditoria</div>
                  </div>
                  <div class="e-content">
                    <div>
                      <legend>Consulta de Datos Actuales</legend>
                      <grid-component
                        ref="ObjAuditGrid"
                        gridName="AuditoriaDatosActuales"
                        :hasRecharge="false"
                        :autoFitColumns="true"
                      >
                      </grid-component>
                    </div>
                    <div>
                      <legend>Consulta Histórica de Auditoria</legend>
                      <div style="text-align: left; display: flex">
                        <div class="col-xs-12 col-sm-6 col-lg-8 col-md-8">
                          <label class="e-text">Rango Consulta Auditoria</label>
                          <ejs-daterangepicker
                            placeholder="Rango Consulta Auditoria"
                            v-model="m_data.searchDate"
                            @change="datePickerChanged"
                            :format="dateFormat"
                            :strictMode="true"
                          >
                            <e-presets>
                              <e-preset
                                label="Esta Semana"
                                :start="weekStartDate"
                                :end="weekEndDate"
                              ></e-preset>
                              <e-preset
                                label="Este Mes"
                                :start="monthStartDate"
                                :end="monthEndDate"
                              ></e-preset>
                              <e-preset
                                label="Mes Pasado"
                                :start="lastMonthStartDate"
                                :end="lastMonthEndDate"
                              >
                              </e-preset>
                              <e-preset
                                label="Año Pasado"
                                :start="lastYearStartDate"
                                :end="lastYearEndDate"
                              >
                              </e-preset>
                            </e-presets>
                          </ejs-daterangepicker>
                        </div>
                        <div
                          class="col-xs-12 col-sm-6 col-lg-4 col-md-4"
                          style="align-self: end"
                        >
                          <ejs-button
                            @click.native="searchDataAudit"
                            :isPrimary="true"
                            iconCss="e-icons e-search inline-command"
                            cssClass="e-flat e-noback"
                            >Consultar Auditoria
                          </ejs-button>
                        </div>
                      </div>
                      <div class="row"><br /></div>
                      <grid-component
                        ref="ObjAuditHistoryGrid"
                        gridName="AuditoriaDatosHistoricos"
                        :hasRecharge="false"
                        :autoFitColumns="true"
                      >
                      </grid-component>
                    </div>
                  </div>
                </ejs-tab>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";

import CultureMixin from "../../mixins/CultureMixin";
import PermissionMixin from "../../mixins/PermissionMixin";
import ToastMixin from "../../mixins/ToastMixin";
//import GridComponent from "../shared/GridComponent.vue";
import GridComponent from "../shared/GridComponentPrimeVue.vue";

/* Plugins de Syncfusion */
import { ButtonPlugin } from "@syncfusion/ej2-vue-buttons";
import { DropDownListPlugin } from "@syncfusion/ej2-vue-dropdowns";
import { TabPlugin } from "@syncfusion/ej2-vue-navigations";
import { DateRangePickerPlugin } from "@syncfusion/ej2-vue-calendars";

import * as Yup from "yup";
import { es } from "yup-locales";
import { setLocale } from "yup";
setLocale(es);

Vue.use(DateRangePickerPlugin);
Vue.use(TabPlugin);
Vue.use(ButtonPlugin);
Vue.use(DropDownListPlugin);

export default Vue.extend({
  mixins: [PermissionMixin, ToastMixin, CultureMixin],
  components: { GridComponent },
  computed: {
    componentsList() {
      let arrayTables = this.$store.getters["audit/allTablesAudit"];
      return arrayTables;
    },
    // currentColumnsList() {
    //   let currentArray = this.$store.getters["audit/allCurrentAudit"];
    //   return currentArray;
    // },
    // historicColumnsList() {
    //   let historicArray = this.$store.getters["audit/allHistoricAudit"];
    //   return historicArray;
    // },
    weekStartDate() {
      return new Date(
        new Date(
          new Date().setDate(
            new Date().getDate() - ((new Date().getDay() + 7) % 7)
          )
        ).toDateString()
      );
    },
    weekEndDate() {
      return new Date(
        new Date(
          new Date().setDate(
            new Date(
              new Date().setDate(
                new Date().getDate() - ((new Date().getDay() + 7) % 7)
              )
            ).getDate() + 6
          )
        ).toDateString()
      );
    },
    monthStartDate() {
      return new Date(new Date(new Date().setDate(1)).toDateString());
    },
    monthEndDate() {
      return new Date(
        new Date(
          new Date(new Date().setMonth(new Date().getMonth() + 1)).setDate(0)
        ).toDateString()
      );
    },
    lastMonthStartDate() {
      return new Date(
        new Date(
          new Date(new Date().setMonth(new Date().getMonth() - 1)).setDate(1)
        ).toDateString()
      );
    },
    lastMonthEndDate() {
      return new Date(new Date(new Date().setDate(0)).toDateString());
    },
    lastYearStartDate() {
      var year = new Date().getFullYear();
      return new Date(year - 1, 0, 1).toDateString();
    },
    lastYearEndDate() {
      var year = new Date().getFullYear();
      return new Date(year - 1, 11, 31).toDateString();
    }
  },
  data() {
    return {
      /* Datos del Componente*/
      fields: { text: "description", value: "id" },
      m_data: {
        id: 1,
        table: "",
        schema: "",
        searchDate: undefined
      },
      currentColumns: [],
      currentData: [],
      historicColumns: [],
      historicData: [],
      validationSchema: {},
      m_errors: {},
      dateFormat: "yyyy/MM/dd"
    };
  },
  created() {},
  async mounted() {
    try {
      //crear el spinner de loading
      this.$parent.showLoading();
      this.buildYupSchema();
      this.$parent.hideLoading();
    } catch (error) {
      console.log(error);
    }
  },
  methods: {
    getCurrentColumnsList() {
      let currentArray = JSON.parse(
        JSON.stringify(this.$store.getters["audit/allCurrentAudit"])
      );
      return currentArray;
    },
    getHistoricColumnsList() {
      let historicArray = JSON.parse(
        JSON.stringify(this.$store.getters["audit/allHistoricAudit"])
      );
      return historicArray;
    },
    clearErrors() {
      this.m_errors = {};
    },
    buildYupSchema() {
      this.validationSchema = Yup.object().shape({
        id: Yup.number()
          .required()
          .typeError("Seleccione un Componente")
          .label("Componente")
      });
    },
    datePickerChanged() {},
    hasError(field) {
      return !!this.m_errors[field];
    },
    async validateField(field, isChange = false) {
      Vue.set(this.m_errors, field, "");

      this.validationSchema.validateAt(field, this.m_data).catch((err) => {
        Vue.set(this.m_errors, err.path, err.message);
        return;
      });

      if (isChange) {
        this.$refs.ObjAuditGrid.clearDataGrid(true);
        this.$refs.ObjAuditHistoryGrid.clearDataGrid(true);
      }
    },
    async searchData() {
      try {
        this.$parent.showLoading();
        this.currentColumns = [];
        this.currentData = [];
        this.historicColumns = [];
        this.historicData = [];
        this.$refs.tabGrid.ej2Instances.select(0);

        await this.validationSchema.validate(this.m_data, {
          abortEarly: false
        });

        this.m_errors = {};

        const array = this.componentsList;
        var data = array.find((x) => x.id == this.m_data.id);

        await this.$store.dispatch("audit/getCurrentAudit", data);

        var arrayColumns = this.getCurrentColumnsList();
        if (arrayColumns != undefined) {
          if (arrayColumns.columns != null) {
            this.currentColumns = Object.keys(arrayColumns.columns).map(
              function (row) {
                let typeString = arrayColumns.columns[row]
                  .toString()
                  .toLowerCase();

                let format = null;
                let type = "string";
                let bool = false;
                if (typeString == "int32" || typeString == "int64") {
                  format = "N";
                  type = "number";
                }
                if (typeString == "datetime") {
                  format = "dd-MM-yyyy HH:mm:ss";
                  type = "datetime";
                }
                if (typeString == "boolean") {
                  bool = true;
                  type = "boolean";
                }
                if (typeString == "string") {
                  bool = true;
                  type = "string";
                }

                return {
                  field: row,
                  header: row,
                  displayAsCheckBox: bool,
                  dataType: type,
                  nullText: "",
                  NullValue: null,
                  format: format
                };
              }
            );
            this.currentData = arrayColumns.data;
            //setTimeout(() => {

            this.$refs.ObjAuditGrid.setGridData(
              this.currentData,
              this.currentColumns
            );

            this.$parent.hideLoading();
            this.showToast(
              "Confirmación",
              "Consulta de datos actuales finalizada!",
              2000
            );

            //}, 500);
            return;
          }
        }

        this.$parent.hideLoading();
        this.showToast(
          "Confirmación",
          "No se encuentra información para el filtro aplicado!",
          2000
        );
      } catch (error) {
        this.$parent.hideLoading();
        error.inner.forEach((error) => {
          Vue.set(this.m_errors, error.path, error.message);
          //this.m_errors[error.path] = error.message;
        });
        this.showToast("Error!", "Ha ocurrido un error en la consulta!", 2000);
      }
    },
    async searchDataAudit() {
      try {
        this.$parent.showLoading();
        this.historicColumns = [];
        this.historicData = [];
        await this.validationSchema.validate(this.m_data, {
          abortEarly: false
        });
        this.m_errors = {};

        this.$refs.ObjAuditHistoryGrid.clearDataGrid(true);

        const array = this.componentsList;
        var data = array.find((x) => x.id == this.m_data.id);

        if (this.m_data.searchDate != null) {
          if (this.m_data.searchDate.length > 0) {
            data.dateFrom = this.m_data.searchDate[0];
            data.dateTo = this.m_data.searchDate[1];
          }
        } else {
          this.$parent.hideLoading();
          this.showToast(
            "Invalido!",
            "Debe seleccionar un rango de fechas para la consulta!",
            2000
          );
          return;
        }

        await this.$store.dispatch("audit/getHistoricAudit", data);

        const arrayColumns = this.getHistoricColumnsList();

        if (arrayColumns != undefined) {
          if (arrayColumns.columns != null) {
            this.historicColumns = Object.keys(arrayColumns.columns).map(
              function (row) {
                let typeString = arrayColumns.columns[row]
                  .toString()
                  .toLowerCase();
                let format = "";
                let type = "string";
                let bool = false;
                if (typeString == "int32") {
                  format = "N";
                  type = "number";
                }
                if (typeString == "datetime") {
                  format = "dd-MM-yyyy HH:mm:ss";
                  type = "dateTime";
                }
                if (typeString == "boolean") {
                  bool = true;
                  type = "boolean";
                }
                return {
                  field: row,
                  displayAsCheckBox: bool,
                  header: row,
                  dataType: type,
                  nullText: "",
                  NullValue: null,
                  format: format
                };
              }
            );
            this.historicData = arrayColumns.data;

            this.$refs.ObjAuditHistoryGrid.setGridData(
              this.historicData,
              this.historicColumns
            );

            this.$parent.hideLoading();
            this.showToast(
              "Confirmación",
              "Consulta de auditoria finalizada!",
              2000
            );
            return;
          }
        }

        this.$parent.hideLoading();
        this.showToast(
          "Confirmación",
          "No se encuentra información para los filtros aplicados!",
          2000
        );
      } catch (error) {
        this.$parent.hideLoading();
        error.inner.forEach((error) => {
          Vue.set(this.m_errors, error.path, error.message);
          //this.m_errors[error.path] = error.message;
        });
        this.showToast("Error!", "Ha ocurrido un error en la consulta!", 2000);
      }
    }
  },
  props: {}
});
</script>

<style>
@import url(../../../node_modules/@syncfusion/ej2-base/styles/fabric.css);
@import url(../../../node_modules/@syncfusion/ej2-vue-buttons/styles/fabric.css);
@import url(../../../node_modules/@syncfusion/ej2-vue-inputs/styles/fabric.css);
@import url(../../../node_modules/@syncfusion/ej2-vue-popups/styles/fabric.css);
@import url(../../../node_modules/@syncfusion/ej2-vue-notifications/styles/fabric.css);
@import url(../../../node_modules/@syncfusion/ej2-vue-lists/styles/fabric.css);
@import url(../../../node_modules/@syncfusion/ej2-dropdowns/styles/fabric.css);
@import url(../../../node_modules/@syncfusion/ej2-vue-calendars/styles/fabric.css);
@import url(../../../node_modules/vue-loading-overlay/dist/vue-loading.css);
@import url(../form-icons.css);

#user-dialog {
  text-align: justify;
}

.dialog-papirus.e-dialog .e-dlg-header {
  color: #0078d6;
  font-size: 20px;
  font-weight: normal;
}

.content-wrapper div.row {
  padding: 5px 0px;
}

.switch-label {
  padding: 0px 0px 0px 20px;
  margin: auto;
  cursor: pointer;
}

.e-save.e-icons:before,
.e-save.e-icons:before {
  content: "\e609";
}

@media only screen and (max-width: 480px) {
  .content-wrapper {
    width: 92%;
  }

  .e-input-section .col-xs-6,
  .e-input-section .col-xs-4,
  .e-input-section .col-xs-12 {
    padding: 10px 5px;
    width: 100%;
  }

  .content-wrapper div.row {
    padding: 0px;
  }
}

.classEspecial {
  align-self: end;
}

.e-search:before {
  content: "\e97d";
}
</style>
